
    var riot = require('riot')
    
riot.tag2('gtranslate', '<div onclick="{translate}" class="translate-buttons"><img src="/images/assets/flags/flag-uk.svg" height="20" class="flag flag-uk"><img src="/images/assets/flags/flag-cy.svg" height="20" class="flag flag-cy"><yield></yield></div>', 'iframe.goog-te-banner-frame { top: -10000px; } .translate-buttons { position: relative; overflow: hidden; min-width: 85px; text-align: center; } .translate-buttons .flag { display: inline-block; margin: 0 3px; -webkit-transition: opacity ease 0.3s; -moz-transition: opacity ease 0.3s; -o-transition: opacity ease 0.3s; -ms-transition: opacity ease 0.3s; transition: opacity ease 0.3s; } .translate-buttons .flag-cy { opacity: 0.5; -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=50)"; filter: alpha(opacity=50); } .translate-buttons #google_translate_element { position: absolute; top: 0; left: 0; right: 0; bottom: 0; opacity: 0; -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)"; filter: alpha(opacity=0); } .translate-buttons #google_translate_element .goog-te-combo { position: relative; top: -100px; } html.translated-ltr body { top: 0 !important; } html.translated-ltr .flag-uk { opacity: 0.5; -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=50)"; filter: alpha(opacity=50); } html.translated-ltr .flag-cy { opacity: 1; -ms-filter: none; filter: none; } @media (max-width: $screen-sm-max) { html.translated-ltr .pushdown { height: 40px; } }', '', function(opts) {
this.translate = (function(_this) {
  return function() {
    var combo, doc, doclink, event, html, iframe;
    html = document.querySelector('html');
    if (html.getAttribute('lang') === "en") {
      combo = document.querySelector('.goog-te-combo');
      combo.selectedIndex = 1;
      if (typeof Event === 'function') {
        event = new Event('change');
      } else {
        event = document.createEvent('Event');
        event.initEvent('change', true, true);
      }
      return combo.dispatchEvent(event);
    } else {
      iframe = document.querySelector('iframe.goog-te-banner-frame');
      doc = iframe.contentDocument ? iframe.contentDocument : iframe.contentWindow.document;
      doclink = doc.querySelector('.goog-close-link');
      return doclink.click();
    }
  };
})(this);
});
    
  